import { render, staticRenderFns } from "./FixedRentalDetails.vue?vue&type=template&id=18ff031c&"
import script from "@/scripts/modal/fixedRentalDetails.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/fixedRentalDetails.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports